import Popover from '@mui/material/Popover';
import React, { useState } from 'react';

const CustomPopover = ({
  anchorElement, // JSX element like <Button> or <div>
  children, // Popover content
  id = 'global-popover',
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
  PaperProps = {},
  className = '',
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // Clone and enhance the anchor element with onClick
  const anchorWithHandler = React.cloneElement(anchorElement, {
    onClick: handleOpen,
  });

  return (
    <>
      {anchorWithHandler}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        PaperProps={PaperProps}
        className={className}
      >
        {children}
      </Popover>
    </>
  );
};

export default CustomPopover;
